
import request from "../../../request";
import { Inventory } from "@mui/icons-material";
import NumberCardStat from "./NumberCardStat";

export default function Products() {
   return <NumberCardStat
      title="Products"
      icon={<Inventory />}
      getNumber={async () => {
         const res = await request.get('/api/general/reports/products');
         return res.data.count.overall;
      }}
   />
}